<div class="dialog-wrapper">
  <button mat-icon-button mat-dialog-close class="close-btn" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>

  @for (item of [
    { cls: 'double-circle', key: 'golf.scoredard.info.eagle.or_better' },
    { cls: 'single-circle',  key: 'golf.scorecard.info.birdie' },
    { cls: 'single-box',     key: 'golf.scorecard.info.bogey' },
    { cls: 'double-box',     key: 'golf.scorecard.info.doublebogey.or_worse' }
    ]; track item) {
    <div class="legend-item">
      <span class="score" [ngClass]="item.cls"></span>
      <span class="label">{{ appStrings.getAppString(item.key) }}</span>
    </div>
  }
</div>
